/**
 * Yetenek, yetkinlik ve temel matematik.
 * Tum fonksiyonlar saf. Girdi degistirilmez.
 */

import { ABILITY_KEYS, type AbilityKey } from './types'

/**
 * Yetenek modifikatörü: floor((puan - 10) / 2)
 *   1 -> -5 ... 8 -> -1, 9-10 -> 0, 11-12 -> +1 ... 20 -> +5, 30 -> +10
 */
export function abilityModifier(score: number): number {
  return Math.floor((score - 10) / 2)
}

/** Puanı modifikatöre cevirir. */
export function modifierToScore(modifier: number): number {
  return 8 + 2 * Math.max(-5, Math.min(14, modifier))
}

/**
 * Seviyeden yetkinlik bonusu (Proficiency Bonus).
 *   Seviye 1-4 -> +2, 5-8 -> +3, 9-12 -> +4, 13-16 -> +5, 17-20 -> +6
 */
export function proficiencyBonus(level: number): number {
  return 2 + Math.floor((Math.max(1, level) - 1) / 4)
}

/** 5e'ye gore zirh tasiyabilirlik sinirlari. */
export const CARRY_CAPACITY_MULTIPLIER = 15

/**
 * Kaldirma kapasitesi: 15 x GUC puani.
 * Yuvarlama: 5'in katina yukari.
 */
export function carryCapacity(strScore: number): number {
  return Math.ceil((strScore * CARRY_CAPACITY_MULTIPLIER) / 5) * 5
}

/** 5e'ye gore yuzme kaldirma kapasitesi. */
export function swimCarryCapacity(strScore: number): number {
  return Math.ceil((strScore * 3) / 5) * 5
}

/**
 * Zarlarin "ortalama" degeri — HP hesabinda kullanilir (fixed/rounded-down).
 *   d6 -> 4, d8 -> 5, d10 -> 6, d12 -> 7
 */
export function averageHitDie(hitDie: number): number {
  return Math.floor(hitDie / 2) + 1
}

/** Kalan iki listenin kesisimi (proficiency anahtarlari icin). */
export function intersect<T>(a: readonly T[], b: readonly T[]): T[] {
  const set = new Set(b)
  return a.filter((item) => set.has(item))
}

/** Bir ability icin dogru modifikatörü, opsiyonel bonusla. */
export function effectiveModifier(
  scores: Record<AbilityKey, number>,
  ability: AbilityKey,
  bonus = 0,
): number {
  return abilityModifier(scores[ability]) + bonus
}

/** Tum yetenekler icin modifikatör tablosu. */
export function allModifiers(scores: Record<AbilityKey, number>): Record<AbilityKey, number> {
  const out = {} as Record<AbilityKey, number>
  for (const key of ABILITY_KEYS) out[key] = abilityModifier(scores[key])
  return out
}

/** Iki karşılaştırma: buyuk harf/kucuk harf duyarsiz, aksan duyarsiz karsilastirma. */
export function normalizeName(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
}
